import { useHistory } from "react-router-dom";
import { DashboardProps, DashboardPropsDefaults } from "../../types/dashboardProps.d";

const DashboardWidgetDirectorReports = ({ user }: DashboardProps): JSX.Element => {
    const history = useHistory();
    return (
        <div className={DashboardPropsDefaults.containerClassNames}>
            <div className="dashboard-widget-title pb-1">
                <h3>Reports</h3>
            </div>
            <div className={DashboardPropsDefaults.contentClassNames}>
                <a className="block mt-2" href="" onClick={() => history.push('/reports/powerbi', { reportId: 'a6485a0d-3524-4838-94a7-9bf87fa1eaf9' })}>Report - a6485a0d-3524-4838-94a7-9bf87fa1eaf9</a>
                <a className="block mt-2" href="" onClick={() => history.push('/reports/powerbi', { reportId: '6112e243-0af3-49b9-93f6-6a9dba7ea29f' })}>Report - 6112e243-0af3-49b9-93f6-6a9dba7ea29f</a>
            </div>
        </div>
    );
};

export default DashboardWidgetDirectorReports;
